import moment from "moment";

function generateTimeSlots(start, end) {
  const slots = [];
  let current = moment(start, "HH:mm");
  const e = moment(end, "HH:mm");

  while (current.isBefore(e)) {
    slots.push(current.format("HH:mm"));
    current.add(30, "minutes");
  }

  return slots;
}

export function checkIfJExistAsignaciones(hour, schedule, day) {
  if (schedule[hour].includes(day)) {
    return true;
  }
  return false;
}

export function checkIfJExistAsignacionesFecha(
  schedule,
  requestStart,
  requestEnd,
  day
) {
  const slots = generateTimeSlots(requestStart, requestEnd);
  for (const slot of slots) {
    const occupiedDays = schedule[slot] || [];
    if (occupiedDays.includes(day)) {
      return true;
    }
  }
  return false;
}
